export function onRouterTransitionStart(url: string, navigationType: "push" | "replace" | "traverse") {
}
